import { DEFAULT_API_BASE_URL, DEFAULT_AUTH_BASE_URL } from "./env-defaults";

const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
const configuredAuthBaseUrl = import.meta.env.VITE_AUTH_BASE_URL;
const configuredStripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const API_BASE_URL = configuredApiBaseUrl || DEFAULT_API_BASE_URL;
export const AUTH_BASE_URL = configuredAuthBaseUrl || DEFAULT_AUTH_BASE_URL;
// The test-mode key is only a dev-server convenience. A build without a configured key has no
// Stripe at all (stripePromise is null), so it can never run checkout in the wrong mode.
const DEV_STRIPE_PUBLISHABLE_KEY = "pk_test_51TlTbZFQDyRti4aoqRRkF3GOtAHlWQtvJvTUAI2ZIRR2eplsCEZ6D66RFcf61yc5QkpkTkNTfhtPwwfdyc2hJ5jH005vU2Anco";

export const STRIPE_PUBLISHABLE_KEY = configuredStripePublishableKey?.trim()
    || (import.meta.env.DEV ? DEV_STRIPE_PUBLISHABLE_KEY : "");

// Observability. See src/telemetry.ts; leaving the endpoint or token unset keeps Dash0 off.
const configuredDash0OtlpEndpoint = import.meta.env.VITE_DASH0_OTLP_ENDPOINT;
const configuredDash0AuthToken = import.meta.env.VITE_DASH0_AUTH_TOKEN;
const configuredDash0Dataset = import.meta.env.VITE_DASH0_DATASET;
const configuredDash0ServiceName = import.meta.env.VITE_DASH0_SERVICE_NAME;
const configuredDash0ServiceVersion = import.meta.env.VITE_DASH0_SERVICE_VERSION;
const configuredDash0Environment = import.meta.env.VITE_DASH0_ENVIRONMENT;
const configuredDash0Disabled = import.meta.env.VITE_DASH0_DISABLED;
const configuredDash0SessionSamplingRate = import.meta.env.VITE_DASH0_SESSION_SAMPLING_RATE;

/** Percentage of sessions to collect, between 0 and 100. Invalid values collect everything. */
function parseSamplingRate(value: string | undefined) {
    const trimmed = value?.trim();

    if (!trimmed) {
        return 100;
    }

    const parsed = Number(trimmed);

    return Number.isFinite(parsed) && parsed >= 0 && parsed <= 100 ? parsed : 100;
}

/** Dash0 regional OTLP/HTTP base URL, without a /v1/* signal path. */
export const DASH0_OTLP_ENDPOINT = configuredDash0OtlpEndpoint?.trim().replace(/\/$/u, "") || "";
/** Dedicated browser token with only Ingesting permission for the frontend dataset. */
export const DASH0_AUTH_TOKEN = configuredDash0AuthToken?.trim() || "";
export const DASH0_DATASET = configuredDash0Dataset?.trim() || "";
export const DASH0_SERVICE_NAME = configuredDash0ServiceName?.trim() || "contentvault-frontend";
export const DASH0_SERVICE_VERSION = configuredDash0ServiceVersion?.trim() || undefined;
export const DASH0_ENVIRONMENT = configuredDash0Environment?.trim() || import.meta.env.MODE;
export const DASH0_DISABLED = configuredDash0Disabled?.trim().toLowerCase() === "true";
export const DASH0_SESSION_SAMPLING_RATE = parseSamplingRate(configuredDash0SessionSamplingRate);
